import { absoluteApiV1Path } from './api'

function encodePathValue(value) {
  if (value === null || value === undefined) return ''
  const clean = String(value).trim()
  return clean ? encodeURIComponent(clean) : ''
}

function appendOgVersion(url, ogVersion) {
  if (!url || ogVersion === null || ogVersion === undefined) return url
  const clean = String(ogVersion).trim()
  if (!clean) return url
  const sep = url.includes('?') ? '&' : '?'
  return `${url}${sep}ogv=${encodeURIComponent(clean)}`
}

export function publicCardOgShareUrl(code, ogVersion) {
  const value = encodePathValue(code)
  return value ? appendOgVersion(absoluteApiV1Path(`share/card/${value}`), ogVersion) : ''
}

export function personalLandingOgShareUrl(code, ogVersion) {
  const value = encodePathValue(code)
  return value ? appendOgVersion(absoluteApiV1Path(`share/landing/${value}`), ogVersion) : ''
}

export function orgLandingOgShareUrl(orgId, ogVersion) {
  const value = encodePathValue(orgId)
  return value ? appendOgVersion(absoluteApiV1Path(`share/org-landing/${value}`), ogVersion) : ''
}

export function categoryLandingOgShareUrl(code, ogVersion) {
  const value = encodePathValue(code)
  return value ? appendOgVersion(absoluteApiV1Path(`share/category-landing/${value}`), ogVersion) : ''
}
